export const slugify = (string: string): string => {
  // strip out special characters that shouldn't be in a url (including underscore), and then turn spaces into kebab-case
  return string
    .toLowerCase()
    .replace(/[^a-z0-9- ]/g, '')
    .replace(/ /g, '-')
}
